import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore, getIsAgencyAdmin, getIsAgencyMember, getIsSystemAdmin } from '@/stores/auth.store';
import type { RouteRole } from '@/config/routes.config';

export function ProtectedRoute({ requiredRole, children }: {
  requiredRole: RouteRole;
  children: ReactNode;
}) {
  const { user } = useAuthStore();
  const allowed =
    requiredRole === 'agency-owner' ? getIsSystemAdmin(user)
    : requiredRole === 'agency-admin' ? getIsAgencyAdmin(user)
    : requiredRole === 'agency-member' ? getIsAgencyMember(user)
    : true;
  if (!allowed) {
    return <Navigate to="/settings/profile" replace />;
  }
  return <>{children}</>;
}
